import { ItemProps } from "../types";
import { ConditionalText } from "./ConditionalText";
import { CountSubtitle } from "./CountSubtitle";

export function ItemSubtitle(props: ItemProps) {
  const {
    uischema: { options },
  } = props;
  const type = options?.subtitle?.type;

  if (type === "count") {
    return <CountSubtitle {...props} />;
  }

  if (type === "conditionalText") {
    return <ConditionalText {...props} />;
  }

  return <></>;
}
